import { RecipeBook } from "./types";
import { appetizerRecipes } from "./appetizers";
import { mainDishRecipes } from "./mainDishes";
import { drinksRecipes } from "./drinks";
import { dessertsRecipes } from "./desserts";
import { extrasRecipes } from "./extras";
import { groceryRecipes } from "./grocery";

// Main Recipe Book - Centralized recipe definitions
// Currently only contains appetizers, will expand to other categories later
export const recipeBook: RecipeBook = {
  ...appetizerRecipes,
  ...mainDishRecipes,
  ...drinksRecipes,
  ...dessertsRecipes,
  ...extrasRecipes,
  ...groceryRecipes,
  // Future: mainDishRecipes, dessertRecipes, etc.
};

// Re-export types
export * from "./types";
